import React, { useState } from 'react';
import Button from '../atoms/Button';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

import backCover1 from '../../assets/images/B-1.jpg';
import backCover2 from '../../assets/images/B-2.jpg';
import backCover3 from '../../assets/images/B-3.jpg';
import backCover4 from '../../assets/images/B-4.jpg';
import backCover5 from '../../assets/images/B-5.jpg';
import backCover6 from '../../assets/images/B-6.jpg';
import backCover7 from '../../assets/images/B-7.jpg';
import backCover8 from '../../assets/images/B-8.jpg';
import backCover9 from '../../assets/images/B-9.jpg';
import backCover10 from '../../assets/images/B-10.jpg';
import backCover11 from '../../assets/images/B-11.jpg';
import backCover12 from '../../assets/images/B-12.jpg';
import backCover13 from '../../assets/images/B-13.jpg';
import backCover14 from '../../assets/images/B-14.jpg';
import backCover15 from '../../assets/images/B-15.jpg';
import backCover16 from '../../assets/images/B-16.jpg';
import backCover17 from '../../assets/images/B-17.jpg';
import backCover18 from '../../assets/images/B-18.jpg';
import cover1 from '../../assets/images/C-1.jpg';
import cover2 from '../../assets/images/C-2.jpg';
import cover3 from '../../assets/images/C-3.jpg';
import cover4 from '../../assets/images/C-4.jpg';
import cover5 from '../../assets/images/C-5.jpg';
import cover6 from '../../assets/images/C-6.jpg';
import cover7 from '../../assets/images/C-7.jpg';
import cover8 from '../../assets/images/C-8.jpg';
import cover9 from '../../assets/images/C-9.jpg';
import cover10 from '../../assets/images/C-10.jpg';
import cover11 from '../../assets/images/C-11.jpg';
import cover12 from '../../assets/images/C-12.jpg';
import cover13 from '../../assets/images/C-13.jpg';
import cover14 from '../../assets/images/C-14.jpg';
import cover15 from '../../assets/images/C-15.jpg';
import cover16 from '../../assets/images/C-16.jpg';
import cover17 from '../../assets/images/C-17.jpg';
import cover18 from '../../assets/images/C-18.jpg';
import cover19 from '../../assets/images/C-19.jpg';
import cover20 from '../../assets/images/C-20.jpg';
import cover21 from '../../assets/images/C-21.jpg';
import cover22 from '../../assets/images/C-22.jpg';
import cover23 from '../../assets/images/C-23.jpg';
import cover24 from '../../assets/images/C-24.jpg';
import greeting1 from '../../assets/images/G-1.jpg';
import greeting2 from '../../assets/images/G-2.jpg';
import greeting3 from '../../assets/images/G-3.jpg';
import greeting4 from '../../assets/images/G-4.jpg';
import greeting5 from '../../assets/images/G-5.jpg';
import greeting6 from '../../assets/images/G-6.jpg';
import greeting7 from '../../assets/images/G-7.jpg';
import greeting8 from '../../assets/images/G-8.jpg';
import greeting9 from '../../assets/images/G-9.jpg';
import greeting10 from '../../assets/images/G-10.jpg';
import greeting11 from '../../assets/images/G-11.jpg';
import greeting12 from '../../assets/images/G-12.jpg';
import greeting13 from '../../assets/images/G-13.jpg';
import greeting14 from '../../assets/images/G-14.jpg';
import greeting15 from '../../assets/images/G-15.jpg';
import greeting16 from '../../assets/images/G-16.jpg';
import greeting17 from '../../assets/images/G-17.jpg';
import greeting18 from '../../assets/images/G-18.jpg';
import greeting19 from '../../assets/images/G-19.jpg';
import greeting20 from '../../assets/images/G-20.jpg';
import profile1 from '../../assets/images/P-1.jpg';
import profile2 from '../../assets/images/P-2.jpg';
import profile3 from '../../assets/images/P-3.jpg';
import profile4 from '../../assets/images/P-4.jpg';
import profile5 from '../../assets/images/P-5.jpg';
import profile6 from '../../assets/images/P-6.jpg';
import profile7 from '../../assets/images/P-7.jpg';
import profile8 from '../../assets/images/P-8.jpg';
import profile9 from '../../assets/images/P-9.jpg';
import profile10 from '../../assets/images/P-10.jpg';
import profile11 from '../../assets/images/P-11.jpg';
import profile12 from '../../assets/images/P-12.jpg';
import profile13 from '../../assets/images/P-13.jpg';
import profile14 from '../../assets/images/P-14.jpg';
import book4_1 from '../../assets/images/4_1.JPG';
import book4_2 from '../../assets/images/4_2.JPG';
import book4_3 from '../../assets/images/4_3.JPG';
import book4_4 from '../../assets/images/4_4.JPG';
import book4_5 from '../../assets/images/4_5.JPG';
import book4_6 from '../../assets/images/4_6.JPG';
import book4_7 from '../../assets/images/4_7.JPG';
import book4_8 from '../../assets/images/4_8.jpg';
import book4_9 from '../../assets/images/4_9.jpg';
import book4_10 from '../../assets/images/4_10.png';
import book4_11 from '../../assets/images/4_11.jpg';
import book4_12 from '../../assets/images/4_12.png';
import book5_1 from '../../assets/images/5_1.JPG';
import book5_2 from '../../assets/images/5_2.JPG';
import book5_3 from '../../assets/images/5_3.JPG';
import book5_4 from '../../assets/images/5_4.JPG';
import book6_1 from '../../assets/images/6_1.JPG';
import book6_2 from '../../assets/images/6_2.jpg';
import book6_3 from '../../assets/images/6_3.jpg';
import book6_4 from '../../assets/images/6_4.jpg';
import book6_5 from '../../assets/images/6_5.jpg';
import book6_6 from '../../assets/images/6_6.jpg';
import book6_7 from '../../assets/images/6_7.jpg';
import book6_8 from '../../assets/images/6_8.jpg';
import book6_9 from '../../assets/images/6_9.jpg';

import photo1 from '../../assets/images/photo_1.JPG';
import photo2 from '../../assets/images/photo_2.JPG';
import photo3 from '../../assets/images/photo_3.JPG';
import photo4 from '../../assets/images/photo_4.JPG';
import photo5 from '../../assets/images/photo_5.JPG';
import photo6 from '../../assets/images/photo_6.JPG';

// import { title } from 'framer-motion/client';

const categories = [
  {
    title: '表紙',
    images: [
      { src: cover1, label: 'C-1' },
      { src: cover2, label: 'C-2' },
      { src: cover3, label: 'C-3' },
      { src: cover4, label: 'C-4' },
      { src: cover5, label: 'C-5' },
      { src: cover6, label: 'C-6' },
      { src: cover7, label: 'C-7' },
      { src: cover8, label: 'C-8' },
      { src: cover9, label: 'C-9' },
      { src: cover10, label: 'C-10' },
      { src: cover11, label: 'C-11' },
      { src: cover12, label: 'C-12' },
      { src: cover13, label: 'C-13' },
      { src: cover14, label: 'C-14' },
      { src: cover15, label: 'C-15' },
      { src: cover16, label: 'C-16' },
      { src: cover17, label: 'C-17' },
      { src: cover18, label: 'C-18' },
      { src: cover19, label: 'C-19' },
      { src: cover20, label: 'C-20' },
      { src: cover21, label: 'C-21' },
      { src: cover22, label: 'C-22' },
      { src: cover23, label: 'C-23' },
      { src: cover24, label: 'C-24' }
    ],
  },
  {
    title: '裏表紙',
    images: [
      { src: backCover1, label: 'B-1' },
      { src: backCover2, label: 'B-2' },
      { src: backCover3, label: 'B-3' },
      { src: backCover4, label: 'B-4' },
      { src: backCover5, label: 'B-5' },
      { src: backCover6, label: 'B-6' },
      { src: backCover7, label: 'B-7' },
      { src: backCover8, label: 'B-8' },
      { src: backCover9, label: 'B-9' },
      { src: backCover10, label: 'B-10' },
      { src: backCover11, label: 'B-11' },
      { src: backCover12, label: 'B-12' },
      { src: backCover13, label: 'B-13' },
      { src: backCover14, label: 'B-14' },
      { src: backCover15, label: 'B-15' },
      { src: backCover16, label: 'B-16' },
      { src: backCover17, label: 'B-17' },
      { src: backCover18, label: 'B-18' }
    ],
  },
  {
    title: 'あいさつ',
    images: [
      { src: greeting1, label: 'G-1' },
      { src: greeting2, label: 'G-2' },
      { src: greeting3, label: 'G-3' },
      { src: greeting4, label: 'G-4' },
      { src: greeting5, label: 'G-5' },
      { src: greeting6, label: 'G-6' },
      { src: greeting7, label: 'G-7' },
      { src: greeting8, label: 'G-8' },
      { src: greeting9, label: 'G-9' },
      { src: greeting10, label: 'G-10' },
      { src: greeting11, label: 'G-11' },
      { src: greeting12, label: 'G-12' },
      { src: greeting13, label: 'G-13' },
      { src: greeting14, label: 'G-14' },
      { src: greeting15, label: 'G-15' },
      { src: greeting16, label: 'G-16' },
      { src: greeting17, label: 'G-17' },
      { src: greeting18, label: 'G-18' },
      { src: greeting19, label: 'G-19' },
      { src: greeting20, label: 'G-20' }
    ],
  },
  {
    title: 'プロフィール',
    images: [
      { src: profile1, label: 'P-1' },
      { src: profile2, label: 'P-2' },
      { src: profile3, label: 'P-3' },
      { src: profile4, label: 'P-4' },
      { src: profile5, label: 'P-5' },
      { src: profile6, label: 'P-6' },
      { src: profile7, label: 'P-7' },
      { src: profile8, label: 'P-8' },
      { src: profile9, label: 'P-9' },
      { src: profile10, label: 'P-10' },
      { src: profile11, label: 'P-11' },
      { src: profile12, label: 'P-12' },
      { src: profile13, label: 'P-13' },
      { src: profile14, label: 'P-14' }
    ],
  },
  {
    title: 'フリーページ',
    images: [
      book4_1, 
      book4_2, 
      book4_3, 
      book4_4,
      book4_5, 
      book4_6, 
      book4_7,
      book4_8,
      book4_9, 
      book4_10, 
      book4_11,
      book4_12,
    ],
  },
  {
    title: '席次表',
    images: [
      book5_1, 
      book5_2, 
      book5_3, 
      book5_4,
    ],
  },
  {
    title: 'メニュー表（料理・ドリンク）',
    images: [
      book6_1, 
      book6_2, 
      book6_3, 
      book6_4,
      book6_5, 
      book6_6, 
      book6_7,
      book6_8, 
      book6_9,
    ],
  }
];

const Gallery = () => {
  const [expandedCategories, setExpandedCategories] = useState([]);
  const [activeTab, setActiveTab] = useState('profileBook');
  const [modalImage, setModalImage] = useState(null);

  const toggleCategory = (index) => {
    setExpandedCategories((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  const openModal = (image) => {
    setModalImage(image);
  };

  const closeModal = () => {
    setModalImage(null);
  };

  const renderProfileBook = () => (
    <div className="space-y-8">
      {categories.map((category, index) => (
        <div key={index} className="border border-gray-300 p-4 shadow-md bg-white">
          {/* Category Header */}
          <div
            className="flex justify-between items-center cursor-pointer"
            onClick={() => toggleCategory(index)}
          >
            <h5 className="text-medium font-bold text-gray-800" style={{ fontFamily: 'zenmaru, serif' }}>
              {category.title}
            </h5>
            <span className="text-gray-500">
              {expandedCategories.includes(index) ? '-' : '+'}
            </span>
          </div>

          {/* Category Images */}
          {expandedCategories.includes(index) && (
            <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 gap-6 mb-6">
              {category.images.map((image, imgIndex) => {
                const src = typeof image === 'object' && image !== null ? image.src : image;
                const label = typeof image === 'object' && image !== null ? image.label : `design ${imgIndex + 1}`;
                return (
                  <div key={imgIndex} className="my-8">
                    {/* LazyLoadImage を使用 */}
                    <LazyLoadImage
                      src={src} // 読み込む画像
                      alt={`${category.title} ${label}`}
                      effect="blur" // ぼかしエフェクト（他に "opacity" なども可）
                      className="w-full h-full object-contain hover:scale-105 transition-transform duration-300 cursor-pointer overflow-hidden border-gray-100 shadow-md hover:shadow-lg"
                      onClick={() => openModal(src)}
                    />
                    <div className="flex justify-center mt-5">
                      <button
                        className="cursor-default px-4 py-2 font-bold border border-gray-400 rounded-full text-sm"
                        style={{ fontFamily: 'Hatton, serif' }}
                      >
                        {label}
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      ))}
    </div>
  );

  const renderWeddingPhoto = () => (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
      {[photo1, photo2, photo3, photo4, photo5, photo6].map((image, index) => (
        <div
          key={index}
          className="overflow-hidden rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300"
        >
          <image
            src={image}
            alt={`Wedding Photo ${index + 1}`}
            className="w-full h-full object-cover hover:scale-105 transition-transform duration-300 cursor-pointer"
            onClick={() => openModal(image)}
          />
        </div>
      ))}
    </div>
  );

  return (
    <section id="gallery" className="p-6 border-t border-black max-w-4xl mx-auto mt-8 pt-16">
      <h2 className="text-3xl font-bold text-center text-gray-800 mb-8 font-serif tracking-wide uppercase" style={{ fontFamily: 'Hatton, serif' }}>
        Gallery
      </h2>

      {/* Toggle Buttons */}
      <div className="flex justify-center space-x-4 mb-8">
        {/* <Button
          label="PROFILE BOOK"
          isActive={activeTab === 'profileBook'}
          onClick={() => setActiveTab('profileBook')}
        /> */}
        {/* <Button
          label="WEDDING PHOTO"
          isActive={activeTab === 'weddingPhoto'}
          onClick={() => setActiveTab('weddingPhoto')}
        /> */}
      </div>

      {/* Conditional Rendering */}
      {activeTab === 'profileBook' && renderProfileBook()}
      {activeTab === 'weddingPhoto' && renderWeddingPhoto()}

      {/* Modal */}
      {modalImage && (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50">
          <div className="relative">
            <LazyLoadImage
              src={modalImage}
              alt="Modal View"
              effect="blur"
              className="max-w-full max-h-screen rounded-lg shadow-lg"
            />
            <button
              className="absolute top-4 right-4 text-white text-2xl font-bold bg-black bg-opacity-50 rounded-full p-2"
              onClick={closeModal}
            >
              &times;
            </button>
          </div>
        </div>
      )}
    </section>
  );
};

export default Gallery;